import { getFlagsManager } from '@databases/flags';

import { EventBus } from './event-bus';
import { BridgeDataChanged } from './events/bridge-data-changed';
import { DatabaseContentIdChanged } from './events/database-content-id-changed';
import { ClearFlagsFromFlagsManager } from './listeners/clear-flags-from-flags-manager';
import { CloseSidePanel } from './listeners/close-side-panel';
import { MaybeDispatchContentIdChanged } from './listeners/maybe-dispatch-content-id-changed';

const eventBus = new EventBus();

/**
 * Register core event listeners. This should be invoked early on in the bootstrapping of the application.
 */
function registerCoreEventListeners() {
  eventBus.register(BridgeDataChanged, () => new MaybeDispatchContentIdChanged(eventBus));
  eventBus.register(DatabaseContentIdChanged, () => {
    const flagsManager = getFlagsManager();

    return new ClearFlagsFromFlagsManager(flagsManager);
  });
}

/**
 * While we transition to an isolated Panels Manager and away from the PanelProvider, this is a temporary
 * solution to register the CloseSidePanels listener.
 * This should only be used in the current PanelProvider.
 */
function registerCloseSidePanelsListener(hidePanels: () => void) {
  eventBus.register(DatabaseContentIdChanged, () => new CloseSidePanel(hidePanels));
}

function getEventBus() {
  return eventBus;
}

export { registerCoreEventListeners, getEventBus, registerCloseSidePanelsListener };
export { Event, type EventListener } from './types';

/**
 * Events to expose
 */
export { BridgeDataChanged } from './events/bridge-data-changed';
